import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getApprovalHistoryList } from 'Store/Component/ApprovalHistoryTab/ApprovalHistoryAction';
import ApprovalHistory from './ApprovalHistory';

const ApprovalHistoryContainer = (props: any) => {
  const { setSelectedKey, tab, tabSwitchClicked, setTabSwitchClicked } = props

  const [historyList, setHistoryList] = useState([])

  const dispatch = useDispatch()
  let { id } = useParams();

  const {
    approvalHistory
  }: any = useSelector((state?: any) => ({
    approvalHistory: state.ApprovalHistoryReducer.approvalHistory,
  }));

  useEffect(() => {
    if (id != undefined) {
      dispatch(getApprovalHistoryList(parseInt(id)))
    }
  }, [id])

  useEffect(() => {
      setHistoryList(approvalHistory)
  }, [approvalHistory])

  useEffect(() => {
    if (tabSwitchClicked) {
      setSelectedKey(tab)
      setTabSwitchClicked(false)
    }
  }, [tabSwitchClicked])


  return (
    <ApprovalHistory approvalHistory={historyList} />
  );
};

export default ApprovalHistoryContainer;